import { Link } from 'react-router-dom';
import { getCurrentRentAmount } from './tenant-helpers';
import numberHelpers from '../../app/number-helpers';

export const TenantTile = ({ tenant }) => {

    const nh = new numberHelpers();

    const tenantLogoPath = tenant => {
        return tenant.logoPathIncludingSasToken;
    }

    const imageNotAvailableClass = tenant => {
        const result = "property product" + (tenantLogoPath(tenant) ? "" : " not-available");
        return result;
    }

    const imageStyle = tenant => {
        const unknown = { marginTop: "20px", alignSelf: "center", maxHeight: "180px", width: "50%", backgroundImage: 'url(/assets/img/pos/unknown-user.png)' };
        const known = { backgroundImage: `url(${tenantLogoPath(tenant)})` };
        return tenantLogoPath(tenant) ? known : unknown;
    }

    return (
        <div key={`tenant-${tenant.id}`} className="product-container" >
            <Link to={`/tenant/detail/${tenant.id}`} className={imageNotAvailableClass(tenant)}>
                <div className="img mt-10px" style={imageStyle(tenant)}></div>
                <div className="text">
                    <div className="property-description mt-auto">{tenant.displayName}</div>
                    <div className="property-description mt-auto">{tenant.phoneNumber}</div>
                    <div className="property-description mt-auto">{tenant.emailAddress}</div>
                    <div className="property-description mt-auto">{tenant.property.property.name}</div>
                    <div className="property-description mt-auto">Landlord: {tenant.landlordOrOwner.displayName}</div>
                    <div className="property-description mt-auto">Current Rent: {getCurrentRentAmount(tenant)}</div>
                    <div className="property-description mt-auto">Balance: {nh.safeParseFloat(tenant.balance, 2)}</div>
                </div>
                {!tenantLogoPath(tenant) && (
                    <div className="not-available-text">
                        <div>Image Not Available</div>
                    </div>
                )}
            </Link>
        </div>
    );
};